import React from 'react';
import { Box, Typography } from '@mui/material';

const QueueMonitor: React.FC = () => {
    const backendUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    
    return (
        <Box sx={{ 
            p: 0,  // Remove padding
            height: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Typography variant="h4" sx={{ p: 2 }}>
                Queue Monitor
            </Typography>
            <Box sx={{ 
                flex: 1,
                width: '100%',
                height: 'calc(100vh - 80px)', // Subtract header height
                overflow: 'hidden'
            }}>
                <iframe
                    src={`${backendUrl}/admin/queues`}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none'
                    }}
                    title="Queue Monitor"
                />
            </Box>
        </Box>
    );
};

export default QueueMonitor; 